const ApiUrl = `${process.env.VUE_APP_API_PP_CIUDADANO}`
import axios from '@/interceptor-core'

export const requestRenunciaMixin = {
  methods: {
    renunciaVerificar() {
      return axios.post(`${ApiUrl}/renuncia/verificar`)
    },
    enviarRenuncia(body) {
      return axios.post(`${ApiUrl}/renuncia/crear`, body);
    },
    getRenunciaVer(id) {
      const body = {
        id: id
      }
      return axios.post(`${ApiUrl}/renuncia/ver`, body);
    },
    getListaRenuncia(body) {
      return axios.post(`${ApiUrl}/renuncia/lista`, body)
    },
  }
};
